/** Format validation only; does not establish that an EIN has been issued. */
export function normalizeEin(input: string): string | null {
  const value = input.trim();
  return /^(?:\d{9}|\d{2}-\d{7})$/.test(value) ? value.replace("-", "") : null;
}
